import { Fragment, useState } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { useEffectOnce } from 'react-use';
import { Divider } from '~/components/ui/Divider';
import { rage, useInputAction } from '~/rage';
import { InputAction } from '~/shared';
import { DepositMoney } from '../../components/DepositMoney';
import { Head } from '../../components/Head';
import { MainMenu } from '../../components/MainMenu';
import { PlayerProfile } from '../../components/PlayerProfile';
import { StartOverlay } from '../../components/StartOverlay';
import { TaxPayment } from '../../components/TaxPayment';
import { Transactions } from '../../components/Transactions';
import { TransferMoney } from '../../components/TransferMoney';
import { WithdrawMoney } from '../../components/WithdrawMoney';
import { resetStore, useLayoutDispatch, useLayoutSelector } from '../../redux';
import {
	StyledContainer,
	StyledMainContainer,
	StyledRightContainer,
} from './Bank.styled';

const menuItems = [
	PlayerProfile,
	DepositMoney,
	WithdrawMoney,
	TransferMoney,
	TaxPayment,
	// ExchangeMoney,
	// PlayerCards,
];

const Bank: React.FC = () => {
	const dispatch = useLayoutDispatch();
	const selectedIndex = useLayoutSelector(
		(state) => state.menuSelection.selectedIndex,
	);
	const [isOverlayVisible, setIsOverlayVisible] = useState(true);
	const ActiveMenuItem = menuItems[selectedIndex];

	useInputAction(InputAction.CommonMenuClose, () => {
		rage.bank.close().catch((err) => rage.notifications.showException(err));
	});

	useEffectOnce(() => {
		rage.bank.fetch().catch((err) => rage.notifications.showException(err));

		return () => {
			dispatch(resetStore());
		};
	});

	return (
		<Fragment>
			<CSSTransition
				in={isOverlayVisible}
				timeout={300}
				classNames={'overlay'}
				unmountOnExit
				appear
			>
				<StartOverlay onSuccess={() => setIsOverlayVisible(false)} />
			</CSSTransition>
			<StyledContainer>
				<MainMenu />
				<StyledRightContainer>
					<Head />
					<Divider
						$direction="H"
						style={{ marginTop: 40, marginBottom: 40, opacity: 0.1 }}
					/>
					<StyledMainContainer>
						<SwitchTransition>
							<CSSTransition
								timeout={300}
								classNames={'menu'}
								key={selectedIndex}
								addEndListener={(node, done) =>
									node.addEventListener('transitionend', done, false)
								}
							>
								<ActiveMenuItem />
							</CSSTransition>
						</SwitchTransition>
						<Transactions />
					</StyledMainContainer>
				</StyledRightContainer>
			</StyledContainer>
		</Fragment>
	);
};

export { Bank };
